angular.module('app.cessao').factory('cetipAutomaticoFactory', ['$http', 'errorService', function ($http, errorService) {

    var _apiName = 'CetipAutomatico';

    var _listar = function (search, options, dataInicio, dataTermino, codigoProdutoRede, tipoIntegracao, situacaoIntegracao) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "CodigoProdutoRede", "value": codigoProdutoRede })
        dto.parms.push({ "name": "TipoIntegracao", "value": tipoIntegracao })
        dto.parms.push({ "name": "Situacao", "value": situacaoIntegracao })

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Listar', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _buscarRegistroPorId = function (options, id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/BuscarRegistroPorId', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _reprocessar = function (codigo) {
        var dto = {};
        dto.id = codigo;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Reprocessar', dto)
    };

    var _listCetipAutomaticoHistorico = function (search, options, dataInicio, dataTermino, codigoProdutoRede, situacaoIntegracao) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "CodigoProdutoRede", "value": codigoProdutoRede });
        dto.parms.push({ "name": "Situacao", "value": situacaoIntegracao });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListCetipAutomaticoHistorico', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var factory = {};

    factory.listar = _listar;
    factory.reprocessar = _reprocessar;
    factory.buscarRegistroPorId = _buscarRegistroPorId;
    factory.listCetipAutomaticoHistorico = _listCetipAutomaticoHistorico;

    return factory;

}]);
